import type { CollectingType, ReturningType } from './transactions'

export enum ItemState {
  Clean = 'S', // Schoon
  Dirty = 'V', // Vuil
}

export enum TransactionStatus {
  New = 0, // Nieuw
  Pending = 30, // InBehandeling
  Confirmed = 31, // Bevestigd
  Processed = 35, // Verwerkt
}

export type Hub = 'Aalsmeer' | 'Naaldwijk' | 'Rijnsburg' | string

export type MultiDepot = {
  branch: Hub
  transactionType: ReturningType | CollectingType
  depots: Depot[]
}

export enum TransactieType {
  NVT = 0,
  UitgifteDock = 1,
  UitgifteMobiel = 2,
  UitgifteVast = 3,
  InnameMobiel = 4,
  InnameVast = 5,
  IVTUit = 7,
  IVTIn = 8,
  IDT = 9,
  Voorraadtelling = 10,
  Vernietiging = 11,
  Inkoop = 12,
  ItemStateOmboeken = 17,
  UitgifteCvvBulk = 18,
  Overboeking = 20,
  Omboek = 21,
  VoorraadtellingBulk = 99,
}

export type Depot = {
  naam: string | null
  vestiging: string | null
  code: string | null
  defaultItemState: string | null
  isGemachtigdFustCode: boolean
}

export type FustAantal = {
  fustCode?: number
  itemState: ItemState
  slepen?: number
  stapelwagens?: number
  pallets?: number
  stapels?: number
  stuks?: number
  totaal?: number
}

export type Fustcode = {
  code: number
  toegestaneItemStates: ItemState[] | null
  description: string
}

export type KlantTransactie = {
  id: string | null
  transactieType: TransactieType
  datum: string
  vervoerderNaam: string | null
  vervoerderNummer: number | null
  opdrachtgever: number | null
  fustAantallen: FustAantal[] | null
  status: TransactionStatus
  subStatus: number
  externeNotitie: string | null
  createdOn: string
  tags: string[] | null
  gerelateerdeTransactieId: string | null
  userName: string | null
  locatie: string | null
  klantnummer: number | null
  klantNaam: string | null
  klantLocatie: string | null
}

export type Transaction = {
  id: string
  transactieType: ReturningType | CollectingType
  datum: Date | string
  createdOn: Date
  locatie: Hub | Depot['code']
  klantLocatie?: string
  klantnummer: number
  vervoerderNummer?: number
  fustAantallen: FustAantal[]
  status: TransactionStatus
  externeNotitie?: string
}

export type BusinessAssociation = {
  id: number
  name: string
  role: string
}

export type CustomerLocation = {
  name: string
  number: string
}

export type GetDepotsRelevantVoorResponse = Depot[]
export type GetDepotsRelevantVoorOfLeegResponse = Depot[]
export type GetFustcodesByDepotResponse = Fustcode[]
export type GetInnameTypesResponse = string[]
export type GetKlantLocatiesResponse = CustomerLocation[]
export type GetTransactiesResponse = KlantTransactie[]
export type CreateTransactieRequest = {
  datum: Date | string
  transactieType: ReturningType | CollectingType
  locatie: Hub | Depot['code']
  klantLocatie?: string
  klantnummer: number
  vervoerderNummer: number
  fustAantallen: FustAantal[]
  externeNotitie?: string
  status: TransactionStatus
}
export type CreateTransactieResponse = Transaction
export type UpdateTransactieRequest = {
  fustAantallen: FustAantal[]
}
export type GetUitgifteTypesResponse = string[]
export type GetVestigingenResponse = string[]

export type GetCustomerSpendingLimitResponse = {
  message: string
  percentage: number
  type: string
}

export type ItemPackagingCombination = {
  fustcode: string
  loadCarrier: string
  stuksPerLoadCarrier: number
}

export type PostLocationManagingRequest = {
  hub: Hub
  time: string | null | undefined
}
